import { ErpPrice, PriceType } from "@tm/models"

export function getPrice(prices: Array<ErpPrice>, type: PriceType): ErpPrice | undefined {
    return prices.find((price) => price && price.type === type)
}
